import {BaseTerms} from "../../../../infrastructure/models/base-terms";

export class BettingPromotionModuleTerms extends BaseTerms {
  BPROMOTION_SECONDARY_TITLE_A = "A special offer for 365Scores Users";
  BPROMOTION_SECONDARY_TITLE_B = "A special offer for 365Scores Users";

  BPROMOTION_MAIN_TITLE_A = "{{ Bonus of $200R }} on your first deposit for new users that open an account now";
  BPROMOTION_MAIN_TITLE_B = "365Scores Users get a \n{{Bonus of $200R}} \n for their first bet";

  BPROMOTION_BUTTON_1_A = "Get The Bonus Now!";
  BPROMOTION_BUTTON_1_B = "I want the Bonus Now!";

  BPROMOTION_BUTTON_2_A = "I’m not interested in sports betting at all";
  BPROMOTION_BUTTON_2_B = "I want, but remind me later";

  BPROMOTION_BUTTON_3_A = "I already have an account";
  BPROMOTION_BUTTON_3_B = "I’m not interested in sport betting";

  BPROMOTION_DISCLAIMER = "Terms And Conditions apply. Gamble Responsibly. 18+";

  WEB_BP_LINK_A_DESKTOP = "https://mediaserver.entainpartners.com/renderBanner.do?zoneId=2126645&tdpeh=Context-BWP_Platform-Desktop_Version-A_OS-Web_$GUID_ga4clientid-$GA_CLIENT_ga4sessionidRLK-$GA4_SESSION&btag=301645";
  WEB_BP_LINK_A_MOBILE = "https://mediaserver.entainpartners.com/renderBanner.do?zoneId=2126645&tdpeh=Context-BWP_Platform-Mobile_Version-A_OS-Web_$GUID_ga4clientid-$GA_CLIENT_ga4sessionidRLK-$GA4_SESSION&btag=301645";

  WEB_BP_LINK_B_DESKTOP = "https://mediaserver.entainpartners.com/renderBanner.do?zoneId=2126645&tdpeh=Context-BWP_Platform-Desktop_Version-B_OS-Web_$GUID_ga4clientid-$GA_CLIENT_ga4sessionidRLK-$GA4_SESSION&btag=301645";
  WEB_BP_LINK_B_MOBILE = "https://mediaserver.entainpartners.com/renderBanner.do?zoneId=2126645&tdpeh=Context-BWP_Platform-Mobile_Version-B_OS-Web_$GUID_ga4clientid-$GA_CLIENT_ga4sessionidRLK-$GA4_SESSION&btag=301645";
}
